import React, { useEffect, useState } from 'react';
import RRHHNativeShell from './RRHHNativeShell';
import { rrhhCoreGet, rrhhCorePost } from './rrhhCoreApi';
import { useAuth } from '../../context/AuthContext';
import { canWrite } from '../../utils/roles';
import PayrollCatalogsPanel from './payrollSettings/PayrollCatalogsPanel';
import PayrollRelationsPanel from './payrollSettings/PayrollRelationsPanel';
import PayrollRulesPanel from './payrollSettings/PayrollRulesPanel';
import PayrollAdjustmentsPanel from './payrollSettings/PayrollAdjustmentsPanel';
import './RRHHNative.css';

const TABS = [
  { id: 'catalogos', label: 'Base laboral' },
  { id: 'relaciones', label: 'Relaciones' },
  { id: 'reglas', label: 'Conceptos y reglas' },
  { id: 'ajustes', label: 'Ajustes y licencias' },
];

export default function LiquidacionParametrosPage() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('catalogos');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const writable = canWrite(user, 'rrhh.liquidacion-parametros');

  async function refresh() {
    setLoading(true);
    try {
      setData(await rrhhCoreGet('/liquidacion/parametros'));
      setError('');
    } catch (err) {
      setError(err.message || 'No se pudieron cargar los parámetros de liquidación.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { refresh(); }, []);

  async function submit(path, payload, successMessage) {
    setSaving(true);
    setError('');
    try {
      await rrhhCorePost(path, payload);
      setNotice(successMessage);
      await refresh();
      return true;
    } catch (err) {
      setError(err.message || 'No se pudo guardar el cambio.');
      return false;
    } finally {
      setSaving(false);
    }
  }

  return <RRHHNativeShell
    title="Parámetros de liquidación"
    subtitle="Catálogos, relaciones y reglas históricas. Personal sigue siendo el padrón maestro del sistema."
  >
    {error && <div className="alert alert-error">{error}</div>}
    {notice && <div className="alert alert-success">{notice}</div>}
    <nav className="rrhh-native-tabs rrhh-payroll-settings-tabs" aria-label="Secciones de parámetros">
      {TABS.map((tab) => <button key={tab.id} type="button" className={`rrhh-native-tab${activeTab === tab.id ? ' active' : ''}`} onClick={() => setActiveTab(tab.id)}>{tab.label}</button>)}
    </nav>
    {loading || !data
      ? <div className="rrhh-native-card rrhh-native-empty">Cargando parámetros de liquidación...</div>
      : <>
        {activeTab === 'catalogos' && <PayrollCatalogsPanel data={data} writable={writable} saving={saving} submit={submit} />}
        {activeTab === 'relaciones' && <PayrollRelationsPanel data={data} writable={writable} saving={saving} submit={submit} />}
        {activeTab === 'reglas' && <PayrollRulesPanel data={data} writable={writable} saving={saving} submit={submit} />}
        {activeTab === 'ajustes' && <PayrollAdjustmentsPanel data={data} writable={writable} saving={saving} submit={submit} />}
      </>}
  </RRHHNativeShell>;
}
